// extracted by mini-css-extract-plugin
export var minWidthLimit = "g_Z";
export var footerM = "g_bD";
export var footTop = "g_bF";
export var footTopDesc = "g_bG";
export var footTopText = "g_bH";
export var footLine = "g_bJ";
export var footTopAddress = "g_bK";
export var footBottom = "g_bL";
export var downloadBar = "g_bM";
export var bd = "g_bN";
export var logo = "g_bP";
export var detail = "g_bQ";
export var bigger = "g_bR";
export var red = "g_bS";
export var footBottomDesc = "g_bT";
export var ft = "g_bV";